@use '../../../../app/styles/common/mixins';

.toast {
  position: absolute;
  top: var(--spasing16);
  left: 50%;
  transform: translateX(-50%);
  z-index: 3; // above gallery arrows (z-index: 2)

  width: 100%;
  max-width: 280px;
  padding: var(--spasing06) var(--spasing12);

  background-color: var(--overlay-bg-medium);
  color: var(--fg-on-filled);
  border-radius: var(--rounding10);

  text-align: center;

  @include mixins.caption-primary-400;

  animation: offer-toast-in 0.2s backwards;
}

.text {
  @include mixins.line-clamp(2);

  // hard cap to exactly two lines (caption-primary-400 is 14px, line-height 1.2)
  max-height: calc(1.2em * 2);
}

@keyframes offer-toast-in {
  from {
    opacity: 0;
    transform: translate(-50%, -8px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}
